import React, { useEffect, useMemo, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import i1 from "../../../../Assets/images/user.png";
import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import { toast } from "react-toastify";
import { z } from "zod";
import Loading from "../../../../components/Common/Loading";
import Toggle from "../../../../components/Common/Toggle";
import {
  ADD_USER,
  GET_USER_BY_ID,
  UPDATE_USER,
} from "../../../../services/ApiCalls";
import { activeInActiveArr } from "../../../../utilities/const";
import fileUploader from "../../../../utilities/fileUploader";
import {
  catchAsync,
  checkResponse,
  removeUnderScoreAndCapitalizeFirstLetter,
} from "../../../../utilities/utilities";
import Loader from "../../../../components/Common/Loader";
import GoogleAutocomplete from "../../../../components/Common/GoogleAutoComplete";
import { useTranslation } from "react-i18next";
const AddEditChildUser = () => {
  const { t } = useTranslation();
  const getSchema = () =>
    z.object({
      first_name: z.string().min(1, { message: "First Name is required" }),
      last_name: z.string().min(1, { message: "Last Name is required" }),
      email: z
        .string()
        .min(1, { message: "Email is required" })
        .email("Invalid email address"),
      location: z.string().min(1, { message: "Location is required" }),
      contactNumber: z.string().min(1, { message: "Phone number is required" }),
      countryCode: z.string().min(1, { message: "Country Code is Required" }),
      status: z.enum(activeInActiveArr, {
        message: "This field is required",
      }),
    });
  const [loader, setLoader] = useState(false);
  const [profileImage, setProfileImage] = useState({});
  const { id } = useParams();
  const [userDetails, setUserUserDetails] = useState();
  const [profileImageLoader, setProfileImageLoader] = useState(false);
  const schema = useMemo(() => getSchema(id), [id]);

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    watch,
    reset,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      first_name: "",
      last_name: "",
      email: "",
      contactNumber: "",
      countryCode: "",
      location: "",
      status: "active",
      lat: "",
      lng: "",
    },
  });
  useEffect(() => {
    if (id && userDetails) {
      reset({
        userId: userDetails?._id || "",
        first_name: userDetails?.first_name || "",
        last_name: userDetails?.last_name || "",
        email: userDetails?.email || "",
        contactNumber:
          userDetails?.countryCode && userDetails?.mobileNumber
            ? userDetails?.countryCode + userDetails?.mobileNumber
            : "",
        countryCode: userDetails?.countryCode || "",
        location: userDetails?.location || "",
        status: userDetails?.status || "active",
        lat: userDetails?.lat || "",
        lng: userDetails?.lng || "",
      });
    }
  }, [id, userDetails, reset]);

  const submitHandler = catchAsync(async (data) => {
    if (!profileImage || Object.keys(profileImage).length === 0) {
      return toast.error("Profile image is required");
    }

    const body = {
      ...data,
      ...(id && { _id: id }),
      profileImage,
      userId: userDetails?._id,
      name: `${data.first_name} ${data.last_name}`.trim(),
      mobileNumber: data.contactNumber.replace(data.countryCode, ""),
    };

    const res = await (id ? UPDATE_USER(body) : ADD_USER(body));
    const success = checkResponse({ res, showSuccess: true });

    if (success) {
      navigate("/manage-user");
    }
  });

  const profileImageHandler = catchAsync(async (e) => {
    setProfileImageLoader(true);
    const res = await fileUploader(e.target.files[0]);

    if (!res) {
      setProfileImageLoader(false);
      return;
    }

    setProfileImageLoader(false);

    setProfileImage(res?.url);
  });

  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await GET_USER_BY_ID(id);
    const success = checkResponse({
      res,
      setData: setUserUserDetails,
      setLoader,
    });
    if (success) setProfileImage(res?.data?.data?.profileImage);
  }, setLoader);

  useEffect(() => {
    if (id) getData();
  }, [id]);

  const handleCancel = () => {
    navigate("/manage-user");
  };

  const addressChangeHandler = (address) => {
    setValue("location", address?.address, { shouldValidate: true });
    setValue("lat", address?.lat, { shouldValidate: true });
    setValue("lng", address?.lng, { shouldValidate: true });
  };

  return (
    <>
      {loader && <Loader />}
      <section className="editUser position-relative py-3">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                <Button
                  onClick={() => navigate(-1)}
                  className="border d-flex align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#fff"
                      stroke="#1E232C"
                      stroke-width="0.2"
                    />
                  </svg>
                </Button>
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  {id ? "Edit " : "Add"} {t("manageUser.user")}
                </h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div
                className="formWrpper px-lg-5 p-md-4 p-3 rounded"
                style={{ background: "#EEEEEE" }}
              >
                <Form onSubmit={handleSubmit(submitHandler)}>
                  <Row>
                    <Col lg="12" className="my-2">
                      <div
                        className="mx-auto position-relative upload text-center"
                        style={{ maxWidth: "max-content" }}
                      >
                        <input
                          type="file"
                          className="file position-absolute h-100 w-100"
                          onChange={profileImageHandler}
                        />
                        <div className="imgWrp position-relative">
                          <span
                            className="icn position-absolute"
                            style={{ right: 0, bottom: 20 }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="22"
                              height="22"
                              viewBox="0 0 26 26"
                              fill="none"
                            >
                              <circle
                                cx="13.2007"
                                cy="12.9282"
                                r="12.3872"
                                fill="#3366FF"
                              />
                              <path
                                d="M9.68021 16.69C9.79021 16.69 9.81221 16.679 9.91121 16.657L11.8912 16.261C12.1002 16.206 12.3092 16.107 12.4742 15.942L17.2702 11.146C18.0072 10.409 18.0072 9.14404 17.2702 8.40704L16.8632 7.97804C16.1262 7.24104 14.8502 7.24104 14.1132 7.97804L9.31721 12.785C9.16321 12.939 9.05321 13.159 8.99821 13.368L8.58021 15.37C8.52521 15.744 8.63521 16.107 8.89921 16.371C9.10821 16.58 9.41621 16.69 9.68021 16.69ZM10.0542 13.577L14.8502 8.77004C15.1692 8.45104 15.7522 8.45104 16.0602 8.77004L16.4782 9.18804C16.8522 9.56204 16.8522 10.09 16.4782 10.453L11.6932 15.26L9.65821 15.601L10.0542 13.577ZM17.2262 17.372H9.10821C8.78921 17.372 8.58021 17.581 8.58021 17.9C8.58021 18.219 8.84421 18.428 9.10821 18.428H17.1822C17.5012 18.428 17.7652 18.219 17.7652 17.9C17.7542 17.581 17.4902 17.372 17.2262 17.372Z"
                                fill="#F2F2F7"
                                stroke="#F8FAFC"
                                stroke-width="0.3"
                              />
                            </svg>
                          </span>
                          {profileImageLoader ? (
                            <div
                              style={{ height: 140, width: 140 }}
                              className="img-fluid rounded-circle object-fit-cover"
                            >
                              <Loading fullSize={true} />
                            </div>
                          ) : (
                            <img
                              style={{ height: 140, width: 140 }}
                              src={profileImage || i1}
                              alt=""
                              className="img-fluid rounded-circle object-fit-cover"
                            />
                          )}
                        </div>
                      </div>
                    </Col>

                    <Col lg="6" md="6" className="my-2">
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          {t("manageUser.firstName")}
                        </label>
                        <input
                          type="text"
                          placeholder="Annette Black"
                          className="form-control"
                          {...register("first_name")}
                        />
                        {errors?.first_name && (
                          <p className="text-danger m-0">
                            {errors?.first_name?.message}
                          </p>
                        )}
                      </div>
                    </Col>

                    <Col lg="6" md="6" className="my-2">
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          {t("manageUser.lastName")}
                        </label>
                        <input
                          type="text"
                          placeholder="Annette Black"
                          className="form-control"
                          {...register("last_name")}
                        />
                        {errors?.last_name && (
                          <p className="text-danger m-0">
                            {errors?.last_name?.message}
                          </p>
                        )}
                      </div>
                    </Col>

                    <Col lg="6" md="6" className="my-2">
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          {t("manageUser.email")}
                        </label>
                        <input
                          type="email"
                          placeholder="jackson.graham@example.com"
                          className="form-control"
                          {...register("email")}
                        />

                        {errors?.email && (
                          <p className="text-danger m-0">
                            {errors?.email?.message}
                          </p>
                        )}
                      </div>
                    </Col>

                    <Col lg="6" md="6" className="my-2">
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          {t("manageUser.phoneNumber")}
                        </label>
                        <Controller
                          control={control}
                          name="contactNumber"
                          render={({ field }) => {
                            return (
                              <PhoneInput
                                {...field}
                                country={"us"}
                                value={field.value}
                                onChange={(value, { dialCode }) => {
                                  setValue("countryCode", dialCode);
                                  field.onChange(value);
                                }}
                              />
                            );
                          }}
                        />{" "}
                        {errors.countryCode ? (
                          <p className="text-danger m-0">
                            {errors?.countryCode?.message}
                          </p>
                        ) : (
                          errors?.contactNumber && (
                            <p className="text-danger m-0">
                              {errors?.contactNumber?.message}
                            </p>
                          )
                        )}
                      </div>
                    </Col>

                    <Col lg="6" md="6" className="my-2">
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          {t("manageUser.address")}
                        </label>

                        <GoogleAutocomplete
                          lat={watch("lat")}
                          lng={watch("lng")}
                          name={"location"}
                          address={watch("location")}
                          onChange={addressChangeHandler}
                        />
                        {errors?.location && (
                          <p className="text-danger m-0">
                            {errors?.location?.message}
                          </p>
                        )}
                      </div>
                    </Col>
                    <Col lg="6" md="6">
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          {t("manageUser.status")}
                        </label>
                        <ul className="list-unstyled ps-0 mb-0 d-flex align-items-start gap-10  ps-2 flex-wrap">
                          {activeInActiveArr.map((item) => {
                            return (
                              <li className="d-flex align-items-center">
                                <input
                                  type="radio"
                                  id={item}
                                  name="status"
                                  value={item}
                                  className="form-check"
                                  {...register("status")}
                                />
                                <label
                                  htmlFor={item}
                                  className="form-label fw-sbold text-muted ps-2 m-0"
                                >
                                  {removeUnderScoreAndCapitalizeFirstLetter(
                                    item
                                  )}
                                </label>
                              </li>
                            );
                          })}
                        </ul>
                        {errors?.status && (
                          <p className="text-danger m-0">
                            {errors?.status?.message}
                          </p>
                        )}
                      </div>
                    </Col>
                    <Col lg="12" className="my-2">
                      <div className="d-flex align-items-center justify-content-center gap-10">
                        <Link to="/manage-user">
                          <Button
                            className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                            type="button"
                          >
                            Back
                          </Button>
                        </Link>
                        <Button
                          className="d-flex align-items-center justify-content-center commonBtn "
                          type="submit"
                          disabled={profileImageLoader}
                        >
                          Submit
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddEditChildUser;
